/**
 * The identity of one row in the per-user usage breakdown.
 *
 * Two of these rows are not people and both carry `userId: null` by design —
 * work a candidate triggered from the public apply page, and work the platform
 * did on its own. Keying the table on `userId` alone gave them one key
 * between them, so React reused one row's DOM for the other on update and the
 * two sets of figures swapped places. Every tenant with a public apply page
 * has both rows.
 *
 * `(userId, actorKind)` is the pair the server already keys them on in
 * `build_by_user` — this is the same pair, so the two ends agree about what
 * makes a row a row.
 */
export const usageRowKey = (row) => {
  if (row?.userId) return row.userId;
  return `unattributed:${row?.actorKind ?? "unknown"}`;
};

export default usageRowKey;
